import React, { useState, useEffect } from "react";
import axios from "../Axiosinstance";
import { Modal, Form, ButtonGroup } from "react-bootstrap";
import { FaMinus, FaPlus } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseURLdyte, buttonBackgroundColor, Password, Username } from "../common";
import {
  FormGroup,
  FormLabel,
  FormControl,
  FormCheck,
  Row,
  Col,
} from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Button from '@mui/material/Button';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

const styles = {

  button: {
    marginTop: "4px",
    width: "100%", // Makes the button responsive
    maxWidth: "137px", // Prevents it from being too wide
    padding: "12px", // Adds better spacing
    fontSize: "16px",
    backgroundColor: "#1e90ff", // Blue color
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    textAlign: "center",
  },
};

const BatchForm = ({ onFormSubmit }) => {
  const [selectedTrainers, setSelectedTrainers] = useState([]);
  const [selectedAssessors, setSelectedAssessors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [facilitatorData, setFacilitatorData] = useState(null);

  const [searchText, setSearchText] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  // const [categories, setCategories] = useState([]);
  const [errorMessages, setErrorMessages] = useState({
    moduleDetails: '',
    moduleNames: ''
  });

  useEffect(() => {
    const fetchData = async () => {
      try {

        const venuesResponse = await axios.get('venues');
        setVenues([{ id: 'Online/Classroom', roomno: 'Online/Classroom' }, ...venuesResponse.data]);
        // const categoriesResponse = await axios.get('categorys');
        // setCategories(categoriesResponse.data);
        fetchFacilitatorDetails();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleSelectTrainer = (trainer) => {
    setSelectedTrainers((prevTrainers) => {
      const isSelected = prevTrainers.includes(trainer);

      if (isSelected) {
        // If the trainer is already selected, show a warning toast
        toast.warn(`${trainer} is already selected as a facilitator!`);
        return prevTrainers;
      } else {
        // If the trainer is not selected, add the trainer and show success toast
        toast.success(`${trainer} added to facilitators for this course!`);
        return [...prevTrainers, trainer];
      }
    });
  };

  const handleSelectAssessor = (assessor) => {
    setSelectedAssessors((prevAssessors) => {
      const isSelected = prevAssessors.includes(assessor);
      if (!isSelected) {
        toast.success(`${assessor} added to facilitator for this course!`);
        return [...prevAssessors, assessor];
      }
      return prevAssessors;
    });
  };

  const handleDeleteTrainer = (trainer) => {
    setSelectedTrainers((prevTrainers) =>
      prevTrainers.filter((t) => t !== trainer)
    );
  };

  const handleDeleteAssessor = (assessor) => {
    setSelectedAssessors((prevAssessors) =>
      prevAssessors.filter((a) => a !== assessor)
    );
  };

  // Function to fetch facilitator details from the API
  const fetchFacilitatorDetails = () => {
    axios
      .get("facilitators")
      .then((response) => setFacilitatorData(response.data))
      .catch((error) =>
        console.error("Error fetching facilitator data:", error)
      );
  };

  const handleAddTrainer = (e) => {
    e.preventDefault();
    fetchFacilitatorDetails();
    setShowModal(true);
  };

  const [formModified, setFormModified] = useState(false);

  useEffect(() => {
    const handleFormModification = () => {
      if (!formModified) {
        setFormModified(true);
      }
    };

    window.addEventListener("input", handleFormModification);

    return () => {
      window.removeEventListener("input", handleFormModification);
    };
  }, [formModified]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (formModified) {
        event.returnValue =
          "You have unsaved changes. Are you sure you want to leave this page?";
      }
    };

    window.onbeforeunload = handleBeforeUnload;

    return () => {
      window.onbeforeunload = null;
    };
  }, [formModified]);

  const [courses, setCourses] = useState([]);
  const [venues, setVenues] = useState([]);
  const [courseImage, setCourseImage] = useState("");

  const [batchData, setBatchData] = useState({
    course: "",
    batchcode: "",
    onlineclasslink: "",

    venue: "",
    status: "",
    courseId: "",
    courseImage: "",
    name: "",
    type: "",
    currentModule: "",
    courseFee: "",
    registrationFee: "",
    courseType: "",

    trainers: facilitatorData,
    assessors: facilitatorData,

    moduleDetails: [
      { id: 1, moduleName: "" },
      { id: 2, moduleName: "" },
      { id: 3, moduleName: "" },
      { id: 4, moduleName: "" },
      { id: 5, moduleName: "" },
      { id: 6, moduleName: "" },
    ],

    moduleNames: [
      { id: 1, moduleName: "" },
      { id: 2, moduleName: "" },
      { id: 3, moduleName: "" },
      { id: 4, moduleName: "" },
      { id: 5, moduleName: "" },
      { id: 6, moduleName: "" },
    ],

    reference: "",
    description: "",
    outcome: "",
    requirement: "",
    // category: { id: '' },

    days: [
      {
        id: "",
        day: "",
        sessionIndex: 0,
        sessions: {
          "Session 1": { startTime: "", endTime: "" },
        },
        startTime: "",
        endTime: "",
      },
    ],

    lessonsPerWeek: "",
    assignment: false,
  });

  const handleInputChange1 = (dayIndex, fieldName, event) => {
    const { value } = event.target;
    const newDays = [...batchData.days];
    newDays[dayIndex] = { ...newDays[dayIndex], [fieldName]: value };
    setBatchData({ ...batchData, days: newDays });
  };

  const getDisabledDays = (dayIndex) => {
    const selectedDays = batchData.days
      .slice(0, dayIndex)
      .map((day) => day.day); // Get days selected in previous rows
    const dayOrder = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];


    const maxSelectedIndex = Math.max(
      ...selectedDays.map((day) => dayOrder.indexOf(day)),
      -1 // Default value if no days are selected
    );

    // Disable days that come before or equal to the max selected index
    return dayOrder.reduce((disabledMap, day, index) => {
      disabledMap[day] = index <= maxSelectedIndex;
      return disabledMap;
    }, {});
  };

  const handleAddRow = () => {
    setBatchData((prevData) => ({
      ...prevData,
      days: [
        ...prevData.days,
        {
          id: "",
          day: "",
          sessionIndex: prevData.days.length,
          sessions: {},
          startTime: "",
          endTime: "",
        },
      ],
    }));
  };

  const handleRemoveRow = (dayIndex) => {
    if (batchData.days.length > 1) {
      const newDays = batchData.days.filter((_, index) => index !== dayIndex);
      setBatchData((prevData) => ({
        ...prevData,
        days: newDays,
      }));
    }
  };

  const handleSessionChange = (dayIndex, sessionIndex, fieldName, event) => {
    const { value } = event.target;
    const newDays = [...batchData.days];
    const sessions = { ...newDays[dayIndex].sessions };
    const sessionKey = `Session ${sessionIndex + 1}`;

    const otherField = fieldName === "startTime" ? "endTime" : "startTime";
    const otherTime = sessions[sessionKey][otherField];

    const newStart = fieldName === "startTime" ? value : otherTime;
    const newEnd = fieldName === "endTime" ? value : otherTime;

    if (!newStart || !newEnd) {
      sessions[sessionKey] = {
        ...sessions[sessionKey],
        [fieldName]: value,
      };
      newDays[dayIndex] = { ...newDays[dayIndex], sessions };
      setBatchData({ ...batchData, days: newDays });
      return;
    }

    if (newStart >= newEnd) {
      alert("Start time must be before end time.");
      return;
    }

    // ✅ Overlap validation
    for (const [key, session] of Object.entries(sessions)) {
      if (key === sessionKey) continue;

      const existingStart = session.startTime;
      const existingEnd = session.endTime;

      if (!existingStart || !existingEnd) continue;

      if (newStart < existingEnd && newEnd > existingStart) {
        alert(`Time conflicts with ${key}. Please select a different time.`);
        return;
      }
    }

    // ✅ Sequence validation: current session should start AFTER previous one ends
    if (sessionIndex > 0) {
      const prevSessionKey = `Session ${sessionIndex}`;
      const prevSession = sessions[prevSessionKey];

      if (prevSession?.startTime && prevSession?.endTime) {
        const prevEnd = prevSession.endTime;

        if (newStart <= prevEnd) {
          alert(`Start time must be after end time of ${prevSessionKey}.`);
          return;
        }
      }
    }

    // ✅ All checks passed, update state
    sessions[sessionKey] = {
      ...sessions[sessionKey],
      [fieldName]: value,
    };

    newDays[dayIndex] = { ...newDays[dayIndex], sessions };
    setBatchData({ ...batchData, days: newDays });
  };

  const handleAddSession = (dayIndex) => {
    const newDays = [...batchData.days];
    const currentSessions = newDays[dayIndex].sessions;
    const newSessionNumber = Object.keys(currentSessions).length + 1; // Adjust if needed

    newDays[dayIndex].sessions = {
      ...currentSessions,
      [`Session ${newSessionNumber}`]: {
        startTime: "",
        endTime: "",
      },
    };

    setBatchData({ ...batchData, days: newDays });
  };

  const handleRemoveSession = (dayIndex, sessionIndex) => {
    const newDays = [...batchData.days];
    const newSessions = { ...newDays[dayIndex].sessions };

    // Delete the session that needs to be removed
    const sessionKeys = Object.keys(newSessions);
    sessionKeys.splice(sessionIndex, 1); // Remove the session key from the array

    // Rebuild the sessions object with updated keys
    const updatedSessions = {};
    sessionKeys.forEach((key, index) => {
      updatedSessions[`Session ${index + 1}`] = newSessions[key];
    });

    // Update the state with new sessions
    newDays[dayIndex] = { ...newDays[dayIndex], sessions: updatedSessions };
    setBatchData({ ...batchData, days: newDays });
  };

  // useEffect(() => {

  //   const fetchVenues = async () => {
  //     try {
  //       const response = await axios.get('venues');
  //       setVenues(response.data);
  //     } catch (error) {
  //       console.error('Error fetching venues:', error);
  //     }
  //   };

  //   fetchVenues();
  // }, []);

  const CLOUDINARY_URL = "https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload";
  const CLOUDINARY_UPLOAD_PRESET = "vldqgwk8";

  const handleImageUpload = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) {
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
      formData.append("public_id", "LMS/courses/" + file.name);

      const response = await fetch(CLOUDINARY_URL, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.secure_url) {
        setCourseImage(data.secure_url);
        setBatchData((prevData) => ({
          ...prevData,
          courseImage: data.secure_url,
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    const sanitizedValue = value.replace(/^\s+/, "");


    // Update both 'batchcode' and 'course' if 'batchcode' is changed
    if (name === "batchcode") {
      setBatchData((prevData) => ({
        ...prevData,
        batchcode: sanitizedValue,
        course: sanitizedValue, // Keep 'course' in sync with 'batchcode'
      }));
    } else if (name === "course") {
      setBatchData((prevData) => ({
        ...prevData,
        course: sanitizedValue,
        batchcode: sanitizedValue, // Keep 'batchcode' in sync with 'course'
      }));
      // } else if (name === 'categoryId') {
      //   setBatchData((prevData) => ({
      //     ...prevData,
      //     category: {
      //       id: value,
      //     },
      //   }));
    } else if (type === "checkbox") {
      setBatchData((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else {
      setBatchData((prevData) => ({ ...prevData, [name]: sanitizedValue }));
    }
  };

  // const handleInputChange = (index, event) => {
  //   const { name, value } = event.target;

  //   // Check if the change is related to the 'day' array
  //   if (index !== undefined) {
  //     // Handle changes in the 'day' array
  //     const updatedDays = [...batchData.day];
  //     updatedDays[index][name] = value;
  //     setBatchData(prevData => ({
  //       ...prevData,
  //       day: updatedDays
  //     }));
  //   } else {
  //     // Handle changes in other form fields
  //     if (name === 'batchcode') {
  //       setBatchData(prevData => ({
  //         ...prevData,
  //         batchcode: value,
  //         course: value,  // Keep 'course' in sync with 'batchcode'
  //       }));
  //     } else if (name === 'course') {
  //       setBatchData(prevData => ({
  //         ...prevData,
  //         course: value,
  //         batchcode: value,  // Keep 'batchcode' in sync with 'course'
  //       }));
  //     } else if (name === 'categoryId') {
  //       setBatchData(prevData => ({
  //         ...prevData,
  //         category: {
  //           id: value,
  //         },
  //       }));
  //     } else {
  //       setBatchData(prevData => ({ ...prevData, [name]: value }));
  //     }
  //   }
  // };

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const trainerNames = selectedTrainers.map((trainer) => trainer);
  const assessorNames = selectedAssessors.map((assessor) => assessor);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (selectedTrainers.length === 0) {
        toast.error("Please add at least one facilitator before submitting!");
        return; // Prevent form submission
      }

      setShowConfirmationModal(true);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleConfirmSubmit = async () => {
    const formattedDays = batchData.days.map((day) => ({
      day: day.day,
      sessions: Object.keys(day.sessions).reduce((acc, key) => {
        acc[key] = day.sessions[key];
        return acc;
      }, {}),
    }));

    // Update batchData with facilitator names
    const updatedBatchData = {
      ...batchData,
      trainers: trainerNames,
      assessors: assessorNames,
      days: formattedDays,
    };

    try {
      if (errorMessages.moduleDetails) {
        console.error('Cannot submit due to validation error:', errorMessages.moduleDetails);
        return; // Exit the function early if there's an error
      }
      const response = await axios.post("batch", updatedBatchData);


      if (response.status === 200) {
        console.log("Batch added successfully:", response.data);
        onFormSubmit();
      } else {
        console.error("Failed to submit batch data.");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setShowConfirmationModal(false);
    }
  };

  const handleCancelSubmit = () => {
    setShowConfirmationModal(false);
  };

  const [showCancelConfirmationModal, setShowCancelConfirmationModal] =
    useState(false);

  const handleCancel = () => {
    setShowCancelConfirmationModal(true);
  };

  const handleConfirmCancel = () => {
    onFormSubmit();
    // Additional cancel logic if needed
    setShowCancelConfirmationModal(false);
  };

  const handleCancelCancel = () => {
    setShowCancelConfirmationModal(false);
  };

  const containerStyle = {
    backgroundColor: "white",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    padding: "20px",
    maxWidth: "800px",
    margin: "auto",
    marginTop: "20px",
  };

  const username = Username;
  const password = Password;
  const baseURL = baseURLdyte;
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [meetingTitle, setMeetingTitle] = useState("");

  const handleShowMeetingModal = () => {
    setShowMeetingModal(true);
  };

  const handleCloseMeetingModal = () => {
    setShowMeetingModal(false);
  };

  const handleMeetingTitleChange = (e) => {
    setMeetingTitle(e.target.value);
  };

  const handleCreateMeeting = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/meetings`,
        {
          title: meetingTitle,
          preferred_region: "ap-south-1",
          record_on_start: false,
          live_stream_on_start: false,
          recording_config: {
            max_seconds: 60,
            file_name_prefix: "string",
            video_config: {
              codec: "H264",
              width: 1280,
              height: 720,
              watermark: {
                url: "http://example.com",
                size: { width: 1, height: 1 },
                position: "left top",
              },
            },
            audio_config: { codec: "AAC", channel: "stereo" },
            storage_config: {
              type: "aws",
              access_key: "string",
              secret: "string",
              bucket: "string",
              region: "us-east-1",
              path: "string",
              auth_method: "KEY",
              username: "string",
              password: "string",
              host: "string",
              port: 0,
              private_key: "string",
            },
            dyte_bucket_config: { enabled: true },

          },
        },
        {
          auth: {
            username: username,
            password: password,
          },
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response && response.data) {
        // Extract the meeting ID from the response
        const meetingId = response.data.data.id;

        // Omit participant addition in this part of the code

        // Construct the complete meeting link using base link, id, and authToken
        const completeMeetingLink = `${baseURL}/meeting?id=${meetingId}`;

        // Update batchData with the meeting link
        setBatchData((prevData) => ({
          ...prevData,
          onlineclasslink: completeMeetingLink,
        }));

        // Close the meeting modal
        handleCloseMeetingModal();
      } else {
        console.error("Invalid response from Dyte API");
      }
    } catch (error) {
      console.error("Error creating meeting:", error);
    }
  };

  const handleModuleChange = (e, id, type) => {
    const { name, value } = e.target;

    // First, update the relevant module data
    const updatedModuleData = batchData[type].map((module) => {
      if (module.id === id) {
        return { ...module, [name]: value };
      }
      return module;
    });

    // Then, check for duplicates using the updated data
    const duplicates = updatedModuleData.filter(
      (module, index, self) =>
        module.moduleName &&
        self.findIndex(m => m.moduleName === module.moduleName) !== index
    );

    // Set error messages accordingly
    if (duplicates.length > 0) {
      setErrorMessages((prev) => ({
        ...prev,
        [type]: 'Module name must be unique.'
      }));
    } else {
      setErrorMessages((prev) => ({
        ...prev,
        [type]: ''
      }));
    }

    // Finally, update the batch data state
    setBatchData((prev) => ({
      ...prev,
      [type]: updatedModuleData
    }));
  };


  const handleModuleSelect = (id) => {
    const updatedBatchData = { ...batchData, currentModule: id };

    setBatchData(updatedBatchData);
  };

  const handleEditorChange = (field) => (value) => {
    setBatchData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  return (
    <div className="batch-form-container">
      <Modal show={showConfirmationModal} onHide={handleCancelSubmit} centered>
        <Modal.Header closeButton>
          <Modal.Title>Save Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to save this Course?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="contained"
            style={{ background: 'red' }}
            onClick={handleCancelSubmit}
          >
            Close
          </Button>
          <Button
            variant="contained"
            style={{ background: buttonBackgroundColor, marginLeft: '10px' }} // adds space between buttons
            onClick={handleConfirmSubmit}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>


      <form onSubmit={handleSubmit} className="container" style={containerStyle}>
        <h2 className="mb-4">Course Form (Jurong Academy)</h2>
        {/* <br /> */}
        <br />
        {/* <br /> */}

        <div className="row">
          <div className="col-md-6">
            {/* Course Name */}
            <div className="form-group mb-3">
              <label htmlFor="batchCode" className="text-start d-block">Course Name:</label>
              <input
                type="text"
                id="batchCode"
                className="form-control"
                name="batchcode"
                value={batchData.batchcode}
                onChange={handleInputChange}
                placeholder="Course Name"
                required
              />
            </div>
          </div>

          <div className="col-md-6">
            {/* Registration Fee */}
            <div className="form-group mb-3">
              <label htmlFor="registrationFee" className="text-start d-block">Registration Fee:</label>
              <input
                type="number"
                id="registrationFee"
                className="form-control"
                name="registrationFee"
                value={batchData.registrationFee}
                onChange={handleInputChange}
                placeholder="Registration Fee"
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            {/* Course Fee */}
            <div className="form-group mb-3">
              <label htmlFor="batchCode" className="text-start d-block">Course Fee:</label>
              <input
                type="number"
                id="courseFee"
                className="form-control"
                name="courseFee"
                value={batchData.courseFee}
                onChange={handleInputChange}
                placeholder="Course Fee"
                required
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group mb-3">
              <label htmlFor="type" className="text-start d-block">Course Type</label>
              <select
                id="type"
                className="form-control"
                name="type"
                value={batchData.type}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Type</option>
                <option value="diploma">Diploma</option>
                <option value="advance_diploma">Advanced Diploma</option>
              </select>
            </div>
          </div>

        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group mb-3">
              <label htmlFor="courseType" className="text-start d-block">Type:</label>
              <select
                id="courseType"
                className="form-control"
                name="courseType"
                // style={{
                //   width: "100%",
                //   height: "46px",
                //   borderRadius: "6px",
                //   border: "1px solid #ced4da",
                // }}
                value={batchData.courseType}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Course Type</option>
                <option value="Part time">Part Time</option>
                <option value="Full time">Full Time</option>
              </select>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group mb-3">
              <label className="text-start d-block">Online Class Link:</label>
              <div className="input-group" >
                <input
                  type="text"
                  className="form-control"
                  name="onlineclasslink"
                  value={batchData.onlineclasslink}
                  onChange={handleInputChange}
                  placeholder="Enter online class link"
                  required
                  style={{
                    height: "43px",
                    borderRadius: "8px 0 0 6px",
                    border: "1px solid #ced4da",
                  }}
                />
                <Button
                  type="button"
                  variant="outline-secondary"
                  onClick={handleShowMeetingModal}
                  style={{
                    background: buttonBackgroundColor,
                    color: "white",
                    border: "none",
                    borderRadius: "0 8px 8px 0",
                    padding: "5px 10px",
                    cursor: "pointer",
                  }}
                >
                  +
                </Button>
              </div>
            </div>
          </div>
        </div>

        <Modal show={showMeetingModal} onHide={handleCloseMeetingModal}>
          <Modal.Header closeButton>
            <Modal.Title>Enter Meeting Title</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Control
              type="text"
              placeholder="Enter meeting title"
              value={meetingTitle}
              onChange={handleMeetingTitleChange}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="contained" color="error" onClick={handleCloseMeetingModal}>
              Close
            </Button>
            <Button variant="contained" style={{ background: buttonBackgroundColor, marginLeft: '2px' }} onClick={handleCreateMeeting}>
              Create
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="row">
          <div className="col-md-6">
            <div className="form-group mb-3">
              <label className="text-start d-block">Venue:</label>
              <select
                name="venue"
                className="form-control"
                value={batchData.venue}
                style={{
                  width: "100%",
                  height: "45px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                }}
                onChange={handleInputChange}
                required
              >
                <option value="" disabled>
                  Select a venue
                </option>
                {venues.map((venue) => (
                  <option key={venue.id} value={venue.roomno}>
                    {venue.roomno}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group mb-3">
              <label htmlFor="fileupload" className="text-start d-block">Course Image:</label>
              <input
                type="file"
                id="fileupload"
                className="form-control"
                name="courseImage"
                onChange={handleImageUpload}
                accept="image/*"
                style={{
                  width: "100%",
                  height: "45px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                }}
                required
              />
            </div>
          </div>
        </div>
        <Row>
          <Col md={6}>
            {/* Input Text Field */}
            <FormGroup>
              <FormLabel className="text-start d-block" >Lessons Per Week</FormLabel>
              <FormControl
                type="number"
                placeholder="Lessons Per Week"
                name="lessonsPerWeek" // Assign name attribute
                value={batchData.lessonsPerWeek}
                onChange={handleInputChange}
              />
            </FormGroup>
          </Col>
        </Row>

        {/* <div> */}
        <h3>Module Details</h3>
        {errorMessages.moduleDetails && (
          <div style={{ color: "red", marginTop: "10px", fontSize: "14px" }}>
            {errorMessages.moduleDetails}
          </div>
        )}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)", // Two modules per row
            gap: "20px", // Space between the module cards
            width: "100%",
            padding: "10px",
          }}
        >
          {batchData.moduleDetails.map((module) => (
            <div key={module.id}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                {/* Radio Button for Module Details */}
                <input
                  type="radio"
                  id={`moduleSelect${module.id}`}
                  name="currentModule"
                  value={module.id}
                  checked={batchData.currentModule === module.id}
                  onChange={() => handleModuleSelect(module.id)}
                  style={{ marginRight: "10px" }}
                  required
                />
                <label htmlFor={`moduleName${module.id}`} style={{ marginRight: "10px" }}>
                  Module {module.id}:
                </label>
              </div>
              <input
                type="text"
                id={`moduleName${module.id}`}
                className="form-control"
                name="moduleName"
                value={module.moduleName}
                onChange={(e) => handleModuleChange(e, module.id, "moduleDetails")}
                placeholder={`Enter Module ${module.id} name`}
                required
              />
            </div>
          ))}
        </div>

        <h3 style={{ width: '100%', textAlign: 'center', fontWeight: 'bold', fontSize: '1.6rem' }}> Module Names for Mark Sheet</h3>
        {errorMessages.moduleNames && (
          <div style={{ color: "red", marginTop: "10px", fontSize: "14px" }}>
            {errorMessages.moduleNames}
          </div>
        )}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)", // Two modules per row
            gap: "20px", // Space between the module cards
            width: "100%",
            padding: "10px",
          }}
        >
          {batchData.moduleNames.map((module) => (
            <div key={module.id}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "5px",
                }}
              >
                {/* No Radio Button for Module Names */}
                <label
                  htmlFor={`moduleName${module.id}`}
                  style={{ marginRight: "10px" }}
                >
                  Module {module.id}:
                </label>
              </div>
              <input
                type="text"
                id={`moduleName${module.id}`}
                className="form-control"
                name="moduleName"
                value={module.moduleName}
                onChange={(e) => handleModuleChange(e, module.id, "moduleNames")}
                placeholder={`Enter Module ${module.id} name`}
                required
              />
            </div>
          ))}
        </div>



        <br />
        <div className="d-flex justify-content-end " style={{ width: "100%" }}>
          <Button
            variant="contained"
            onClick={handleAddTrainer}
            style={{
              background: buttonBackgroundColor,
              color: "white",
              fontSize: "12px",
            }}
          >
            <FaPlus /> Add Trainer
          </Button>
        </div>
        {/* </div> */}

        <Modal
          show={showModal}
          onHide={handleCloseModal}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Trainer/Assessor Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row align-items-center">
              <div className="col-md-4">
                <div className="input-group mb-3">
                  <span
                    className="input-group-text"
                    style={{ height: "45px" }}
                  >
                    Search
                  </span>
                  <input
                    type="text"
                    id="search"
                    className="form-control"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ height: "45px" }}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="input-group mb-3">
                  <span className="input-group-text">Show</span>
                  <select
                    id="itemsPerPage"
                    className="form-control"
                    value={itemsPerPage}
                    onChange={(e) =>
                      setItemsPerPage(Number(e.target.value))
                    }
                    style={{ height: "45px" }}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                  </select>
                </div>
              </div>
            </div>

            {facilitatorData && facilitatorData.length > 0 ? (
              <>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>NRIC</th>
                        <th>Add Trainer</th>
                        <th>Add Assessor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {facilitatorData
                        .filter(
                          (facilitator) =>
                            facilitator.name
                              .toLowerCase()
                              .includes(searchText.toLowerCase()) ||
                            facilitator.email
                              .toLowerCase()
                              .includes(searchText.toLowerCase()) ||
                            facilitator.nric
                              .toLowerCase()
                              .includes(searchText.toLowerCase())
                        )
                        .slice(
                          (currentPage - 1) * itemsPerPage,
                          currentPage * itemsPerPage
                        )
                        .map((facilitator) => {
                          const isTrainerSelected =
                            selectedTrainers.includes(
                              facilitator.name + "(" + facilitator.id + ")"
                            );
                          const isAssessorSelected =
                            selectedAssessors.includes(
                              facilitator.name + "(" + facilitator.id + ")"
                            );

                          // Determine if the Add buttons should be disabled
                          const disableAddTrainer =
                            selectedTrainers.length >= 1 ||
                            isTrainerSelected;
                          const disableAddAssessor =
                            selectedAssessors.length >= 1 ||
                            isAssessorSelected;

                          return (
                            <tr key={facilitator.id}>
                              <td>{facilitator.name}</td>
                              <td>{facilitator.email}</td>
                              <td>{facilitator.nric}</td>
                              <td>
                                <Button
                                  variant="contained"
                                  type="button"
                                  onClick={() =>
                                    handleSelectTrainer(
                                      facilitator.name +
                                      "(" +
                                      facilitator.id +
                                      ")"
                                    )
                                  }
                                  disabled={disableAddTrainer}
                                  style={{
                                    backgroundColor: disableAddTrainer
                                      ? "#d3d3d3"
                                      : buttonBackgroundColor,
                                    color: "white",
                                    border: "none",
                                    padding: "10px 20px",
                                    borderRadius: "7px",
                                  }}
                                >
                                  <FaPlus /> Add
                                </Button>
                              </td>
                              <td>
                                <Button
                                  variant="contained"
                                  onClick={() =>
                                    handleSelectAssessor(
                                      facilitator.name +
                                      "(" +
                                      facilitator.id +
                                      ")"
                                    )
                                  }
                                  disabled={disableAddAssessor}
                                  style={{
                                    backgroundColor: disableAddAssessor
                                      ? "#d3d3d3"
                                      : buttonBackgroundColor,
                                    color: "white",
                                    border: "none",
                                    padding: "10px 20px",
                                    borderRadius: "7px",
                                  }}
                                >
                                  <FaPlus /> Add
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "end",
                    float: "inline-end",
                  }}
                >
                  <div
                    className="pagination"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Button
                      className="btn btn-outline-primary"
                      onClick={() =>
                        setCurrentPage((prevPage) =>
                          Math.max(prevPage - 1, 1)
                        )
                      }
                      disabled={currentPage === 1}
                      style={{ width: "100px", marginRight: "10px" }}
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </Button>
                    <span className="mx-2">Page {currentPage}</span>
                    <Button
                      className="btn btn-outline-primary"
                      onClick={() =>
                        setCurrentPage((prevPage) =>
                          Math.min(
                            prevPage + 1,
                            Math.ceil(facilitatorData.length / itemsPerPage)
                          )
                        )
                      }
                      disabled={
                        currentPage ===
                        Math.ceil(facilitatorData.length / itemsPerPage)
                      }
                      style={{ width: "100px" }}
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <p>No facilitator data found.</p>
            )}
          </Modal.Body>
        </Modal>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px",
            marginTop: "20px",
            width: "100%",
          }}
        >
          {/* Trainers Container */}
          {selectedTrainers.length > 0 && (
            <div
              style={{
                flex: "1",
                minWidth: "300px",
                padding: "20px",
                border: "1px solid #ddd",
                borderRadius: "10px",
                backgroundColor: "#f9f9f9",
              }}
            >
              <h3>Selected Trainers</h3>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {selectedTrainers.map((trainer, index) => {
                  const trainerName = trainer.match(/^[^\d()]*/)[0].trim();
                  return (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "10px 0",
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                      }}
                    >
                      <div>
                        {index + 1}. {trainerName}
                      </div>
                      {/* <Button
                        variant="contained"
                        onClick={() => handleDeleteTrainer(trainer)}
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          border: "none",
                          padding: "8px 16px",
                          borderRadius: "7px",
                          cursor: "pointer",
                        }}
                      >
                        Remove
                      </Button> */}
                      <DeleteRoundedIcon
                        fontSize="large"
                        className="text-danger"
                        style={{ color: 'red', marginLeft: 10 }}
                        onClick={() => handleDeleteTrainer(trainer)}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          {/* Assessors Container */}
          {selectedAssessors.length > 0 && (
            <div
              style={{
                flex: "1",
                minWidth: "300px",
                padding: "20px",
                border: "1px solid #ddd",
                borderRadius: "10px",
                backgroundColor: "#f9f9f9",
              }}
            >
              <h3>Selected Assessors</h3>
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {selectedAssessors.map((assessor, index) => {
                  const assessorName = assessor.match(/^[^\d()]*/)[0].trim();
                  return (
                    <li
                      key={index}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        margin: "10px 0",
                        padding: "10px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                      }}
                    >
                      <div>
                        {index + 1}. {assessorName}
                      </div>
                      {/* <Button
                        variant="contained"
                        onClick={() => handleDeleteAssessor(assessor)}
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          border: "none",
                          padding: "8px 16px",
                          borderRadius: "7px",
                          cursor: "pointer",
                        }}
                      >
                        Remove
                      </Button> */}
                      <DeleteRoundedIcon
                        fontSize="large"
                        className="text-danger"
                        style={{ color: 'red', marginLeft: 10 }}
                        onClick={() => handleDeleteAssessor(assessor)}
                      />
                    </li>
                  );
                })}
              </ul>

            </div>
          )}
          {/* <div className="row">
            <p>
              Total Selected Facilitators:{" "}
              {selectedTrainers.length + selectedAssessors.length}
            </p>
          </div> */}
        </div>
        <div className="mb-4 p-2 mt-3" style={{ border: "1px solid #ddd", borderRadius: "10px", backgroundColor: "#fdfdfd", width: '100%', }}>
          <div className="mb-3 text-center position-relative">
            <h3 className="mb-0">Schedule</h3>
            <div style={{ position: "absolute", right: 0, top: 0 }}>
              <Button
                variant="contained"
                style={{
                  background: buttonBackgroundColor,
                  fontSize: "12px",
                  padding: "6px 16px",
                  minWidth: "80px",
                }}
                onClick={handleAddRow}
              >
                + Add Day
              </Button>
            </div>
          </div>
          {batchData.days.map((day, dayIndex) => (
            <div key={dayIndex} className="border rounded p-3 mb-3">
              <Row className="align-items-end mb-3">
                <Col md={3}>
                  <label htmlFor={`day-${dayIndex}`} className="text-start d-block">Select Day:{dayIndex + 1}</label>
                  <select
                    id={`day-${dayIndex}`}
                    className="form-control"
                    name="day"
                    value={day.day}
                    onChange={(event) => handleInputChange1(dayIndex, "day", event)}
                    required
                  >
                    <option value="" disabled>Select a day</option>
                    {[
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                      "Sunday",
                    ].map((dayName) => {
                      const disabledDays = getDisabledDays(dayIndex);
                      return (
                        <option key={dayName} value={dayName} disabled={disabledDays[dayName]}>
                          {dayName}
                        </option>
                      );
                    })}
                  </select>
                </Col>

              </Row>

              {Object.keys(day.sessions).map((sessionKey, sessionIndex) => (
                <Row key={`${dayIndex}-${sessionIndex}`} className="align-items-end mb-3">
                  <Col md={2}>
                    <label className="text-start d-block">Session</label>
                    <input
                      type="text"
                      className="form-control"
                      value={sessionKey}
                      readOnly
                    />
                  </Col>
                  <Col md={4}>
                    <label className="text-start d-block">Start Time</label>
                    <input
                      type="time"
                      className="form-control"
                      value={day.sessions[sessionKey].startTime}
                      onChange={(e) => handleSessionChange(dayIndex, sessionIndex, "startTime", e)}
                      required
                    />
                  </Col>
                  <Col md={4}>
                    <label className="text-start d-block">End Time</label>
                    <input
                      type="time"
                      className="form-control"
                      value={day.sessions[sessionKey].endTime}
                      onChange={(e) => handleSessionChange(dayIndex, sessionIndex, "endTime", e)}
                      required
                    />
                  </Col>
                  <Col md={2} className="text-center">
                    <Button
                      variant="contained"
                      color="error"
                      style={{ height: "47px", fontSize: "12px", margin: '10px 0px 4px 0px' }}
                      onClick={() => handleRemoveSession(dayIndex, sessionIndex)}
                    >
                      Remove Session
                    </Button>
                  </Col>
                </Row>
              ))}

              {/* <div className="d-flex justify-content-end"> */}
              <Button variant="contained"
                style={{ background: buttonBackgroundColor, marginRight: '20px' }}
                onClick={() => handleAddSession(dayIndex)}>
                + Add Session
              </Button>
              {batchData.days.length > 1 && (
                // <Col md="auto">
                <Button variant="contained"
                  color="error" onClick={() => handleRemoveRow(dayIndex)}>
                  Remove Day
                </Button>
                // </div>
                // </Col>
              )}
            </div>
          ))}


        </div>

        <FormGroup className="p-3 border rounded bg-light mb-4" style={{ width: "100%" }}>
          <FormLabel className="mb-2" style={{ fontWeight: "bold", fontSize: "1.4rem" }}>
            Assignment
          </FormLabel>
          <div className="d-flex align-items-center">
            <FormCheck
              type="checkbox"
              label="Assignment"
              name="assignment"
              id="assignment"
              checked={batchData.assignment}
              onChange={handleInputChange}
            />
            <span className={batchData.assignment ? "text-success" : "text-danger"}>
              {batchData.assignment ? "Yes" : "No"}
            </span>
          </div>
        </FormGroup>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "2%",
            }}
          >
            <Button
              type="submit"
              variant="contained"
              color="success"
              style={{
                maxWidth: "15.5%",
                // backgroundColor: "green",
                fontSize: "13px",
              }}
            >
              Submit
            </Button>
            <Button
              variant="contained"
              type="button"
              onClick={handleCancel}
              style={{
                maxWidth: "15.5%",
                backgroundColor: "red",
                fontSize: "13px",
                marginLeft: "10px",
              }}
            >
              Close
            </Button>
          </div>
        </div>
      </form >

      <Modal
        show={showCancelConfirmationModal}
        onHide={handleCancelCancel}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Cancel Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel?</Modal.Body>
        <Modal.Footer>
          <Button variant="contained"
            style={{ background: 'red' }} onClick={handleCancelCancel}>
            No
          </Button>
          <Button variant="contained" style={{ background: buttonBackgroundColor, marginLeft: '10px' }} onClick={handleConfirmCancel}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="bottom-right" />
    </div >
  );
};

const New = ({ onFormSubmit }) => {
  return (
    <div>
      <BatchForm onFormSubmit={onFormSubmit} />
    </div>
  );
};

export default New;
